const HOURS_PER_DAY = 24;

// Cell width is always the width of ONE DAY — positioning math, drag/resize
// snapping, and scroll sizing all assume one column = one calendar day. The
// daily view's hourly columns are a visual subdivision of the day cell, so
// its width is 24 hour slots of 30px each.
const daily = {
  height: 30,
  width: 30 * HOURS_PER_DAY,
};

const weekly = {
  height: 30,
  width: 30,
};

const monthly = {
  height: 30,
  width: 14,
};

const yearly = {
  height: 30,
  width: 2.8,
};

export { daily, weekly, monthly, yearly, HOURS_PER_DAY };
